import React from 'react';
import '../src/css/App.scss';
import Nav from './Components/nav.jsx';
import Landing from './Components/Landing.jsx';
import Seperateur from './Components/Separateur.jsx';
// import Weare from './Components/Weare.jsx'; // à réactiver avec <Weare /> plus bas
import Ourservices from './Components/CertificatesGrid.jsx';
import Projets from './Components/Projets.jsx';
import Contact from './Components/contact.jsx';
import StarrySky from './Components/StarrySky.jsx'; // Ensure the path is correct
import VisitTracker from './Components/VisitTracker.jsx';

function App() {
  return (
    <div className="App" style={{ scrollBehavior: "smooth" }}>
      <VisitTracker />
      <StarrySky />
      <Nav />
      <Landing />
      <Seperateur type="My certificates?" id="services"/>
      <Ourservices />
      
      <Seperateur type="My projects ?" id="projects"/>
      <Projets />
      {/* <Seperateur type="Who I am ?" id="about-me"/>
      <Weare /> */}
      
      <Seperateur type="Contact me" id="contact"/>
      <Contact />
    </div>
  );
}


export default App;
